import DropdownCategory from "components/DropdownCategory";
import React from "react";
import styled from "styled-components/macro";
import { DesktopLarge, device, toRem } from "theme/Breakpoints";
import { DefaultText } from "theme/GlobalElements";

interface ContentTopSectionProps {
  itemsLength: number;
  isFromSearch?: boolean;
}

const ContentTopSection: React.FC<ContentTopSectionProps> = ({
  itemsLength,
  isFromSearch = false,
}) => {
  return (
    <TopSection>
      <DefaultText fontSize={18}>
        Показване на {itemsLength} продукта
      </DefaultText>
      {!isFromSearch && (
        <SortButton>
          <DropdownCategory />
        </SortButton>
      )}
    </TopSection>
  );
};

const TopSection = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
  align-items: center;

  margin-bottom: 10px;
  @media only screen and (${device.tablet}) {
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
  }
  @media only screen and (${device.laptop}) {
    padding: 0;
  }
`;
TopSection.displayName = "TopSection";

const SortButton = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;
SortButton.displayName = "SortButton";

export default ContentTopSection;
